<template>
  <div class="hello">
    <div>
      <div id="wrapper" class="clearfix">
        <section id="content">
          <div class="content-wrap">
            <div class="container clearfix">
              <div
                class="tabs mx-auto mb-0 clearfix"
                style="max-width: 500px;"
              >
                <div class="tab-container">
                  <div class="tab-content" >
                    <div class="card mb-0">
                      <div class="card-body" style="padding: 40px;">
                        <form @submit.prevent="fnSingIn"
                          id="login-form"
                          name="login-form"
                          class="mb-0"
                        >
                          <h3>Bem vindo ao sistema de gerenciamento</h3>

                          <div class="row">
                            <div class="col-12 form-group">
                              <label for="login-form-username">Login:</label>
                              <input
                                type="text"
                                id="login-form-username"
                                name="login-form-username"
                                value=""
                                class="form-control"
                                v-model="user.login"
                              />
                            </div>

                            <div class="col-12 form-group">
                              <label for="login-form-password">Senha:</label>
                              <input
                                type="password"
                                id="login-form-password"
                                name="login-form-password"
                                value=""
                                class="form-control"
                                v-model="user.senha"
                              />
                            </div>

                            <div class="col-12 form-group">
                              <button
                                class="button button-3d button-black m-0"
                                id="login-form-submit"
                                name="login-form-submit"
                                value="login"
                              >
                                Acessar
                              </button>
                              <a href="#" class="float-right"
                                >Esqueceu a senha?</a
                              >
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- #content end -->
      </div>
    </div>
    
  </div>
</template>

<script>

</script>
<script>
import {mapState} from 'vuex'
import Rodape from "../components/_include/Rodape";
import { getError, userKey } from '../global/utils';
export default {
  name: "Auth",
  data() {
    return {
      user:{}
    }
  },
  components: {
    Rodape
  },
  mounted() {

  },
  methods: {
    async fnSingIn(){
      await this.$http.post("listausuarios/auth",this.user)
      .then(res => {
          console.log(res.data)
            this.$store.commit("setUser",res.data)
            localStorage.setItem(userKey, JSON.stringify(res.data))
            window.location.href = "/paineldegerenciamento"
        })
        .catch(()=>{})
    }  
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .content-wrap{
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
</style>
